/**
 * Commission + PG settlement terms shown on order commission views.
 */

export const COMMISSION_FLOW_TERMS = {
  partnerName: "Question Mark Pizza Point",
  platformCommissionPct: 10,
  platformCommissionNote: "10% flat on menu items and add-ons",
  pgRatePct: 2.36,
  pgPlatformNote: "2.36% (2% + 18% GST) on platform commission",
  pgCafeNote: "2.36% (2% + 18% GST) on base, add-ons & delivery",
  codPgNote: "Cash on delivery — no payment gateway; PG fees are ₹0",
  settlement: "T+2",
};
